/* Beutezeit Mindestbestellwert (MOV) 15 EUR — smarter Cart-Nudge + Checkout-Gate.
   Erkennt Beutezeit-Artikel per vendor, blockt Checkout (Button/Links/Express) nur wenn
   0 < Beutezeit-Anteil < 15 EUR, zeigt Fortschritts-Nudge + Top-up. 2026-06-20. */
(function(){
  if (window.__dsBzMov) return; window.__dsBzMov = 1;
  var MOV = 1500;            // 15,00 EUR in Cent
  var VENDOR = 'Beutezeit';
  var COLL = '/collections/barf-hund';

  var css = '.ds-bz-mov{font-family:-apple-system,BlinkMacSystemFont,"SF Pro Text","Segoe UI",Roboto,sans-serif;'
    + 'background:rgba(0,122,255,.06);border:.5px solid rgba(0,122,255,.22);border-radius:14px;padding:13px 15px;margin:0 0 12px;text-align:left}'
    + '.ds-bz-mov__txt{font-size:13.5px;line-height:1.45;color:#1d1d1f;margin:0 0 9px}'
    + '.ds-bz-mov__txt strong{font-weight:600}'
    + '.ds-bz-mov__bar{height:6px;border-radius:9999px;background:rgba(0,0,0,.08);overflow:hidden;margin:0 0 10px}'
    + '.ds-bz-mov__bar>span{display:block;height:100%;background:#007AFF;border-radius:9999px;transition:width .4s cubic-bezier(.4,0,.2,1)}'
    + '.ds-bz-mov__cta{display:inline-flex;align-items:center;justify-content:center;background:#007AFF;color:#fff;'
    + 'font:600 13.5px/1 inherit;letter-spacing:-.01em;padding:11px 18px;border-radius:10px;text-decoration:none}'
    + '.ds-bz-mov__cta:active{transform:scale(.97)}'
    + '.ds-bz-mov__sugg{display:flex;flex-wrap:wrap;gap:7px;margin:0 0 11px}'
    + '.ds-bz-mov__add{appearance:none;border:.5px solid rgba(0,0,0,.14);background:rgba(255,255,255,.7);backdrop-filter:saturate(1.2) blur(6px);'
    + 'color:#1d1d1f;font:500 12.5px/1.2 inherit;letter-spacing:-.01em;padding:8px 11px;border-radius:9999px;cursor:pointer;white-space:nowrap}'
    + '.ds-bz-mov__add:hover{background:#fff;border-color:rgba(0,0,0,.22)}'
    + '.ds-bz-mov__add:active{transform:scale(.96)}'
    + '.ds-bz-mov__add:disabled{opacity:.5;cursor:default}'
    + '.ds-bz-blocked{opacity:.4!important;pointer-events:none!important;filter:grayscale(.3)}'
    + '.ds-bz-hide{display:none!important}';

  function injectCss(){ if(document.getElementById('ds-bz-mov-css'))return; var s=document.createElement('style'); s.id='ds-bz-mov-css'; s.textContent=css; document.head.appendChild(s); }
  function euro(c){ return (c/100).toFixed(2).replace('.',',') + ' €'; }
  function getCart(cb){ fetch('/cart.js',{headers:{'Accept':'application/json'},credentials:'same-origin'}).then(function(r){return r.json();}).then(cb).catch(function(){}); }

  function beutezeitSum(cart){
    var s=0;
    (cart.items||[]).forEach(function(it){
      if((it.vendor||'')===VENDOR){ s += (it.final_line_price!=null ? it.final_line_price : it.line_price); }
    });
    return s;
  }

  // Kuratierte Schnell-Auffuell-Vorschlaege (schliessen die Luecke effizient)
  var SUGG=[
    {h:'barf-mix-rind-tiefgekuehlt', label:'BARF-Mix Rind 1kg'},
    {h:'nassfutter-rind-gereift-400g', label:'Nassfutter Rind im Glas'},
    {h:'hundesnack-rinderlunge-500g', label:'Rinderlunge 500g'}
  ];
  function addBz(handle, btn){
    var orig = btn ? btn.textContent : '';
    if(btn){ btn.disabled=true; btn.textContent='…'; }
    fetch('/products/'+handle+'.js').then(function(r){return r.json();}).then(function(p){
      var avail=(p.variants||[]).filter(function(v){return v.available;});
      if(!avail.length){ throw new Error('nicht verfuegbar'); }
      avail.sort(function(a,b){return b.price-a.price;}); // groesste Variante = schliesst Luecke schneller
      return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:avail[0].id,quantity:1}]})});
    }).then(function(r){
      if(!r||!r.ok){ throw new Error('add fehlgeschlagen'); }
      // Theme re-rendert Cart-Liste/Summe nach AJAX nicht selbst -> Reload garantiert konsistente Anzeige (Position + Summe + Nudge).
      window.location.reload();
    }).catch(function(){ if(btn){ btn.disabled=false; btn.textContent=orig||'+ hinzufügen'; } });
  }
  function nudge(missing, sum){
    var pct = Math.max(4, Math.min(100, Math.round(sum/MOV*100)));
    var d=document.createElement('div');
    d.className='ds-bz-mov';
    var sugg=SUGG.map(function(s){ return '<button type="button" class="ds-bz-mov__add" data-bz-add="'+s.h+'">+ '+s.label+'</button>'; }).join('');
    d.innerHTML='<p class="ds-bz-mov__txt"><strong>Frischfutter von Beutezeit</strong> kommt frisch aus eigener Manufaktur und hat einen Mindestbestellwert von 15 €. Nur noch <strong>'+euro(missing)+'</strong>.</p>'
      +'<div class="ds-bz-mov__bar"><span style="width:'+pct+'%"></span></div>'
      +'<div class="ds-bz-mov__sugg">'+sugg+'</div>'
      +'<a class="ds-bz-mov__cta" href="'+COLL+'">Alle BARF-Sorten ansehen</a>';
    d.querySelectorAll('[data-bz-add]').forEach(function(b){ b.addEventListener('click', function(){ addBz(b.getAttribute('data-bz-add'), b); }); });
    return d;
  }

  function nudgeAnchors(){
    // Nudge nur EINMAL je Kontext: oberster Cart-Trio (hero) + Drawer-Trio. final/sticky werden blockiert, aber nicht doppelt benudgt.
    var t=Array.from(document.querySelectorAll('.ds-checkout-trio--hero,.ds-checkout-trio--drawer'));
    if(!t.length){ var f=document.querySelector('.ds-checkout-trio'); if(f) t=[f]; }
    return t;
  }

  function apply(cart){
    injectCss();
    var sum=beutezeitSum(cart);
    var block = sum>0 && sum<MOV;
    // alte Nudges weg
    document.querySelectorAll('.ds-bz-mov').forEach(function(n){n.remove();});
    var btns=document.querySelectorAll('button[name="checkout"]');
    var links=document.querySelectorAll('a[href="/checkout"],a[href^="/checkout?"]');
    var express=document.querySelectorAll('.additional-checkout-buttons,.dynamic-checkout__content,[data-shopify="dynamic-checkout-cart"]');
    if(block){
      var missing=MOV-sum;
      btns.forEach(function(b){ b.disabled=true; b.classList.add('ds-bz-blocked'); });
      links.forEach(function(a){ a.classList.add('ds-bz-blocked'); a.setAttribute('aria-disabled','true'); });
      express.forEach(function(e){ e.classList.add('ds-bz-hide'); });
      nudgeAnchors().forEach(function(box){ if(!box.parentNode) return; box.parentNode.insertBefore(nudge(missing,sum), box); });
    } else {
      btns.forEach(function(b){ b.disabled=false; b.classList.remove('ds-bz-blocked'); });
      links.forEach(function(a){ a.classList.remove('ds-bz-blocked'); a.removeAttribute('aria-disabled'); });
      express.forEach(function(e){ e.classList.remove('ds-bz-hide'); });
    }
  }

  // Klicks auf blockierte Checkout-Elemente abfangen (Capture)
  document.addEventListener('click', function(e){
    var t=e.target.closest ? e.target.closest('a.ds-bz-blocked,button.ds-bz-blocked') : null;
    if(t){ e.preventDefault(); e.stopImmediatePropagation(); var n=document.querySelector('.ds-bz-mov'); if(n) n.scrollIntoView({behavior:'smooth',block:'center'}); }
  }, true);

  function refresh(){ getCart(apply); }

  // Re-Check nach jeder AJAX-Cart-Mutation
  var _f=window.fetch;
  if(_f){ window.fetch=function(){ var args=arguments, p=_f.apply(this,args); try{ var u=args[0]; var url=(typeof u==='string')?u:(u&&u.url)||''; if(/\/cart\/(add|change|update|clear)/.test(url)){ p.then(function(){ setTimeout(refresh,180); }); } }catch(e){} return p; }; }

  ['cart:updated','cart:refresh','cart:open','cart:bundle-added','cart:change','cart:added'].forEach(function(ev){ document.addEventListener(ev, function(){ setTimeout(refresh,120); }); });
  if(document.readyState!=='loading'){ refresh(); } else { document.addEventListener('DOMContentLoaded', refresh); }
})();
